import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from '@cocoonspace/ui/components/collapsible'
import { FormControlledInput } from '@cocoonspace/ui/components/form-controlled-input'
import { Input } from '@cocoonspace/ui/components/input'
import { Textarea } from '@cocoonspace/ui/components/textarea'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { ChevronDownIcon } from 'lucide-react'

import {
	SectionTitle,
	SectionWrapper,
} from '~/components/sheet-section-wrapper'
import { useFormSectionCollapsible } from '../use-form-section-collapsible.hook'
import { DurationSelect } from './duration_select'
import { MeetingBufferSelect } from './meeting_buffer_select'
// import { PageLanguageSelect } from './page_language_select'

export const GeneralTab = () => {
	const { t } = useLingui()
	const { hasErrors, onOpenChange, open } = useFormSectionCollapsible(
		['title', 'description', 'duration', 'meetingBuffer', 'locale'],
		true,
	)

	return (
		<Collapsible
			open={open}
			onOpenChange={onOpenChange}
		>
			<SectionWrapper className='mt-6'>
				<SectionTitle>
					<CollapsibleTrigger
						className={cn(
							'flex w-full items-center gap-2 text-left [&[data-state=open]>svg]:rotate-180',
							{ 'text-destructive': hasErrors },
						)}
					>
						{t`Informations générales`}
						<ChevronDownIcon className='ml-auto size-4 shrink-0 transition-transform' />
					</CollapsibleTrigger>
				</SectionTitle>

				<CollapsibleContent className='relative flex flex-col gap-1'>
					<FormControlledInput
						label={t`Titre`}
						name='title'
						classNames={{ formItem: '!pb-0', formMessage: 'static' }}
						render={({ field }) => (
							<Input
								{...field}
								inputSize='sm'
							/>
						)}
					/>

					<FormControlledInput
						label={t`Description`}
						name='description'
						classNames={{ formItem: '!pb-0', formMessage: 'static' }}
						render={({ field }) => (
							<Textarea
								{...field}
								className='min-h-[60px]'
								value={field.value}
							/>
						)}
					/>

					<FormControlledInput
						label={t`Durée`}
						name='duration'
						classNames={{ formItem: '!pb-0', formMessage: 'static' }}
						render={({ field }) => <DurationSelect {...field} />}
					/>

					<FormControlledInput
						label={t`Délai entre rendez-vous`}
						name='meetingBuffer'
						classNames={{ formItem: '!pb-0', formMessage: 'static' }}
						render={({ field }) => <MeetingBufferSelect {...field} />}
					/>

					{/* <div className='grid grid-cols-1 items-start gap-4 md:grid-cols-2'>
					<FormControlledInput
						label={t`Durée`}
						name='duration'
						render={({ field }) => <DurationSelect {...field} />}
					/>

					<FormControlledInput
						label={t`Langue de la page`}
						name='locale'
						render={({ field }) => <PageLanguageSelect {...field} />}
					/>
				</div> */}
				</CollapsibleContent>
			</SectionWrapper>
		</Collapsible>
	)
}
